import { LoginComponent } from "./container/login/login.component";
import { AutoLoginComponent } from "./container/auto-login/auto-login.component";

export const routes = [
  { path: 'login', component: LoginComponent},
  { path: 'auto-login/:challengeId/:studentName/:studentId', component: AutoLoginComponent}
]
